import { isEmpty } from "shared/lib/arrayUtils"
import { BuildingType } from "shared/types/references/BuildingType"
import { RoomType } from "shared/types/references/RoomType"

import z from "zod"

export const productFilterFormDataSchema = z.object({
  searchTerm: z.string().optional().nullable(),
  buildingTypes: z.array(z.enum(BuildingType)).optional().nullable(),
  roomTypes: z.array(z.enum(RoomType)).optional().nullable(),
  productGroups: z.array(z.string()).optional().nullable()
})

export type ProductFilterFormData = z.infer<typeof productFilterFormDataSchema>

export function hasProductFilter(formData: ProductFilterFormData) {
  return (
    !!formData.searchTerm ||
    !isEmpty(formData.buildingTypes) ||
    !isEmpty(formData.roomTypes) ||
    !isEmpty(formData.productGroups)
  )
}
